import React, { useContext, useState } from 'react';
import STC from '../../../../STCLibrary/STCFactory/STCFactory';
import { LoginAPIs } from '../../../../API/LoginAPIs/LoginAPIs';
import { useNavigate } from 'react-router-dom';
import NotificationContext from '../../../../STCLibrary/NotificationSystem/NotificationContext';
import ApiResponseHandler from '../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';

function CreateAccountForm() {

    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const [accountCreated, setAccountCreated] = useState(false);
    const [sending, setSending] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [email, setEmail] = useState('');
    const [confirmEmail, setConfirmEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [username, setUsername] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [matchingPasswords, setMatchingPasswords] = useState(true);
    const [termsAccepted, setTermsAccepted] = useState(false);

    const validatePassword = (value, confirmed) => {

        if(value !== confirmed){
            setErrorMsg(`Passwords do not match.`);
            console.log('Not Match');
            return false;
        }

        if (value.length < 12) {
            setErrorMsg(`Password must be at least ${12} characters long.`);
            console.log('Not 12');
            return false;
        }
        if (!/[A-Za-z]/.test(value)) {
            setErrorMsg("Password must contain at least one letter.");
            console.log('Not Letter');
            return false;
        }

        if (!/[0-9]/.test(value)) {
            setErrorMsg("Password must contain at least one number.");
            console.log('Not num');
            return false;
        }

        return true;

    }

    const handleSubmitRegistration = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setSending(true);
        setMatchingPasswords(true);

        const postJSON = {
            email: email,
            emailConfirm: confirmEmail,
            telephoneNumber: phone,
            password: password,
            passwordConfirm: confirmPassword,
            role: "registered_parent"
        }

        if (validatePassword(password, confirmPassword) && (email === confirmEmail)) {
            LoginAPIs.PostRegister(postJSON)
                .then((response) => {
                    setSending(false);
                    if (response.status === 200 && !response.data.error) {
                        setAccountCreated(true);
                        ApiResponseHandler(response, notificationCtx, navigate);
                    } else {
                        setErrorMsg(response.data.error);
                        setMatchingPasswords(false);
                    }
                })
                .catch((err) => {
                    setSending(false);
                    ApiResponseHandler(err.response, notificationCtx, navigate);
                })
        } else {
            setMatchingPasswords(false);
            setSending(false);
        }
    }

    if (accountCreated) {
        return (
            <div className='mt-2'>
                <STC.Alert variant='success'>
                    Successfully created account! Please check the inbox of {email} to verify your account. If you cannot see the verification email, you can log in and request a new verification link from the 'Passengers' section.
                </STC.Alert>
            </div>
        )
    } else {
        return (
            <div className='mt-2'>
            <STC.Alert variant='warning' style={{textAlign: 'center', fontSize: 'x-small'}}>
                This is not a Group Leader Portal. Please contact your sales representative for access.
            </STC.Alert>
                <STC.Form onSubmit={handleSubmitRegistration}>

                    <STC.Form.FloatingLabel className="mb-3">
                        <STC.Form.Control
                            id="floatingInputFirstName"
                            value={email}
                            type="email"
                            disabled={sending}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Email"
                            required
                            isInvalid={!matchingPasswords}
                        />
                        <label style={{marginLeft: '0.5rem'}} htmlFor="floatingInputFirstName">Email</label>
                    </STC.Form.FloatingLabel>

                    <STC.Form.FloatingLabel className="mb-3">
                        <STC.Form.Control
                            id="floatingInputLastName"
                            value={confirmEmail}
                            type="email"
                            disabled={sending}
                            onChange={(e) => setConfirmEmail(e.target.value)}
                            placeholder="Confirm Email"
                            required
                            isInvalid={!matchingPasswords}
                        />
                        <label style={{marginLeft: '0.5rem'}} htmlFor="floatingInputLastName">Confirm Email</label>
                    </STC.Form.FloatingLabel>

                    <STC.Form.FloatingLabel className="mb-3">
                        <STC.Form.Control
                            id="floatingInputPhone"
                            value={phone}
                            type="tel"
                            disabled={sending}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="Phone"
                            maxLength={20}
                            required
                        />
                        <label style={{marginLeft: '0.5rem'}} htmlFor="floatingInputPhone">Phone</label>
                    </STC.Form.FloatingLabel>

                    <STC.Form.FloatingLabel className="mb-3">
                        <STC.Form.Control
                            id="floatingInputPassword"
                            value={password}
                            type="password"
                            disabled={sending}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Password"
                            required
                            minLength={12}
                            isInvalid={!matchingPasswords}
                        />
                        <label style={{marginLeft: '0.5rem'}} htmlFor="floatingInputPassword">Password</label>
                    </STC.Form.FloatingLabel>

                    <STC.Form.FloatingLabel className="mb-3">
                        <STC.Form.Control
                            id="floatingInputPasswordConf"
                            value={confirmPassword}
                            type="password"
                            disabled={sending}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm Password"
                            required
                            minLength={12}
                            isInvalid={!matchingPasswords}
                        />
                        <label style={{marginLeft: '0.5rem'}} htmlFor="floatingInputPasswordConf">Confirm Password</label>
                    </STC.Form.FloatingLabel>

                   
                    <div className="my-3">
                        <STC.Form.Check
                            type="checkbox"
                            id="termsCheckbox"
                            label={
                                <span>
                                    I agree to the{' '}
                                    <a href="https://schooltour.ie/booking-conditions/" target="_blank" rel="noopener noreferrer">
                                        Booking Conditions
                                    </a>
                                    .
                                </span>
                            }
                            checked={termsAccepted}
                            onChange={(e) => setTermsAccepted(e.target.checked)}
                        />
                    </div>

                    {!matchingPasswords && <span className='mt-1' style={{ color: "red" }}>{errorMsg}</span>}

                    <div className="mt-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
                        <div />
                        <div align={'right'}>
                            <STC.Button
                                size='sm'
                                disabled={sending || !termsAccepted}
                                className={'cmn-button login-button'}
                                type={'submit'}
                            >
                                {sending ? 'Submitting' : 'Submit'}
                            </STC.Button>
                        </div>
                    </div>

                </STC.Form>
            </div>
        )
    }
}
export default CreateAccountForm;
